import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./scss/po.scss";
import {
  PURCHASE_ORDER,
  CREATE_PURCHASE_ORDER,
  VENDOR_PAYMENT,
  SUPPLIERS,
  PROJECT_MANAGEMENT,
} from "../../../constants/route-paths";
import {
  getPOList,
  deletePurchaseOrder,
  getProjectList,
  downloadProjectPO,
} from "./../../../actions/project-management.action";
import idx from "idx";
import { format } from "date-fns";
import POFilter from "./po-list-filter";
import PayInvoice from "../../vendor-payment/pay-invoice";
import _ from "lodash";
import DownloadDialog from "../../../components/download-dialog";
import DeleteDialog from "../../../components/delete-dialog";
import { warningSnackBar } from "./../../../actions/common.action";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { getGlobalSettingTemplateTypes } from "./../../../actions/global-setting-template.action";
import { withRouter } from "../../../util/with-router";
import Popover from 'react-bootstrap/Popover';
import CustomTable from "../../../components/table/table";
import { poListColumns } from "../data/po";
import { TemplateType } from "../../../util/enums";
import { useSelector } from "react-redux";

function SuppliersPurchaseOrderList({ writePermission, projectModule, ...props }) {
  const entitlements = useSelector(state => state.user.entitlements)

  const [state, setState] = useState({
    poList: [],
    projectsList: [{ key: "All Projects", value: "all" }],
    selectedProject: "all",
    vendorType: "all",
    workType: "project",
    templateOptions: [],
    showPOFilter: false,
    downloadData: {
      open: false,
      id: "",
    },
    openDeleteDialog: false,
  })

  useEffect(() => {
    getPOList();
    getProjectList();
  }, [])

  const getProjectList = async () => {
    let projectsList = [];
    let projects = await props.getProjectList(null, "PROJECT");
    projects.forEach((project) => projectsList.push({ key: project.name, value: project.id }));

    projectsList = _.orderBy(
      projectsList,
      [({ key }) => key.toLowerCase()],
      ["asc"]
    );

    projectsList.unshift({ key: "All Projects", value: "all" });
    setState(prev => ({
      ...prev,
      projectsList
    }))
  };

  const getPOList = async (projectId = "", isDePo = null) => {
    let { list: poList } = await props.getPOList({ projectId, vendorType: 'Supplier', isDePo });

    const POs = [];
    let fields = ['street_address', 'suburb', 'state', 'postcode', 'country']
    Array.isArray(poList) && poList.forEach((po) => {
      const vendorName = idx(po, (_) => _.vendor.business_name) || "";
      const vendorId = idx(po, (_) => _.vendor.id) || "";
      const type = idx(po, (_) => _.vendor.type) || "";
      let po_address = [];
      for (const iterator of fields) {
        if (idx(po, _ => _[iterator])) po_address.push(idx(po, _ => _[iterator]))
      }
      const status = idx(po, (_) => _.status) || "";
      const materialstatus = idx(po, (_) => _.materialstatus) || "";
      const invoicestatus = idx(po, (_) => _.invoicestatus) || "";
      const project = idx(po, (_) => _.project.name) || "";
      const issueDate = po.createdAt ? format(new Date(po.createdAt), "dd/MM/yyyy") : "";
      const total = parseFloat(po.totalCost || 0);
      POs.push({
        total,
        vendorName,
        type,
        address: po_address.join(', ') || idx(po, (_) => _.vendor.address.replace(/ /g, ', ')),
        project,
        issueDate,
        id: po.id,
        f_id: po.f_id,
        poId: po.u_id,
        vendorId,
        status,
        projectId: po.projectId,
        materialstatus,
        invoicestatus,
        is_credit_invoice: idx(po, _ => _.is_credit_invoice) || false,
        receive_credit_amount: idx(po, _ => _.receive_credit_amount)
      });
    });
    setState(prev => ({
      ...prev,
      poList: POs
    }))
  };

  const createPo = () => {
    props.history(`/${SUPPLIERS}/${CREATE_PURCHASE_ORDER}`);
  };

  const editPo = () => {
    const { workType, poId } = state;
    props.history(`/${SUPPLIERS}/${PURCHASE_ORDER}/edit/${poId}/${workType}`);
  };

  const viewPO = () => {
    const { workType, poId } = state;
    props.history(`/${SUPPLIERS}/${PURCHASE_ORDER}/view/${poId}/${workType}`);
  };

  const deleteDialogState = () => {
    setState(prev => ({
      ...prev,
      openDeleteDialog: !prev.openDeleteDialog,
    }))
  };

  const deleteHandler = async () => {
    const { poId } = state;
    await props.deletePurchaseOrder(poId, "Purchase Order Deleted successfully");
    deleteDialogState();
    getPOList();
  };

  const deleteDescription = () => {
    const { poId, poList } = state
    const PO = poList.find(_ => _.poId === poId)
    const poNo = idx(PO, _ => _.id)
    return `Purchase Order - ${poNo}`;
  }

  const poFilterHandler = () => {
    setState(prev => ({
      ...prev,
      showPOFilter: !prev.showPOFilter,
    }))
  };

  const changeFilter = (projectId, isDePo = null) => {
    if (projectId === "all") { projectId = ""; }
    poFilterHandler();
    getPOList(projectId, isDePo);
  };


  const handleMenu = (rowData) => {
    setState(prev => ({
      ...prev,
      poId: rowData.poId,
      invoiceData: {
        poNumber: rowData.poId,
        poNo: rowData.id,
        status: rowData.status,
      },
    }))
  };

  const handlePayInvoiceModal = (status, allProjects = false) => {
    setState(prev => ({
      ...prev,
      showPayInvoice: status,
      invoiceData: { ...(allProjects ? {} : { ...prev.invoiceData }) },
    }))
  };

  const viewInvoices = () => {
    const { poId, workType } = state;
    props.history(`/${SUPPLIERS}/${VENDOR_PAYMENT}?poId=${poId}&type=${workType}`);
  };

  const gettemplate = async (type = TemplateType.PURCHASE_ORDER) => {
    let newdata = [];
    const templateData = await props.getGlobalSettingTemplateTypes(type, null);
    if (Array.isArray(templateData)) {
      templateData.forEach((item) => {
        newdata.push({
          value: item.id,
          key: item.name,
        });
      });
    }
    setState(prev => ({
      ...prev,
      templateOptions: newdata
    }))
  };

  const handleDownloadDialog = (id = "", templateType = TemplateType.PURCHASE_ORDER, overrideData = null) => {
    const { downloadData, poId, templateOptions = [] } = state;
    const currentId = id && (typeof id === 'string' || typeof id === 'number') ? id : poId;
    const isOpening = !downloadData.open;
    
    const newDownloadData = {
      open: isOpening,
      id: currentId || "",
      template: "",
      overrideData: overrideData
    };

    if (isOpening) {
      gettemplate(templateType);
    }

    setState(prev => ({
      ...prev,
      downloadData: newDownloadData
    }))
  };

  const downloadFile = async (fileFormat = "pdf", tempId) => {
    const { downloadData } = state;
    try {
      if (fileFormat === "pdf" || fileFormat === "ALL") {
        await props.downloadProjectPO(downloadData.id, fileFormat, tempId, undefined, downloadData.overrideData).catch(e => console.error(e));
      }
      if (fileFormat === "docx" || fileFormat === "ALL") {
        await props.downloadProjectPO(downloadData.id, fileFormat, tempId, undefined, downloadData.overrideData).catch(e => console.error(e));
      }
      handleDownloadDialog();
    } catch (error) {
       console.error(error);
    }
  };

  return (
    <>
      <DeleteDialog
        open={state.openDeleteDialog}
        id={state.poId}
        deleteHandler={deleteHandler}
        dialogClose={deleteDialogState}
        moduleName="Purchase Order"
        description={deleteDescription()}
      />
      <DownloadDialog
        {...(state.downloadData || {})}
        downloadFile={downloadFile}
        templateOptions={state.templateOptions}
        handleDownloadDialog={handleDownloadDialog}
        downloadModuleName="Purchase Order"
      />
      {state.showPayInvoice && (
        <PayInvoice
          {...(state.invoiceData || {})}
          poId={state.poId}
          workType={"project"}
          handleDownloadDialog={handleDownloadDialog}
          handleClose={() => handlePayInvoiceModal(false)}
        />
      )}
      {state.showPOFilter && <POFilter
        projectsList={state.projectsList}
        changeFilter={changeFilter}
        workType={state.workType}
        open={state.showPOFilter}
        dialogClose={poFilterHandler}
      />}

      {!projectModule ? (
        <p>
          You do not currently have access to any Projects Finance. Please
          contact your Administrator if this is required.
        </p>
      ) : (
        <>
          <div className="purchase-order-block" data-cy="supplier-po-list">
            <div className="row">
              <div className="w-auto">
                <h2 className="content-heading text-uppercase" data-cy="supplier-po-list-heading">Purchase Order</h2>

              </div>
              {writePermission && (<div className="w-auto ms-auto mt-auto">
                <button onClick={createPo} className="secondarybtn secondarybtn-outline btn-ch ms-auto me-2 btn btn-primary" data-cy="create-po-button">Create PO</button>
                <span onClick={poFilterHandler} className="filter-icon" data-cy="filter-icon"><FilterAltIcon /></span>
              </div>)}
            </div>

            <div className="row">
              <div className="col-12 mt-3">
                <CustomTable
                  columns={poListColumns}
                  data={state.poList}
                  isAction={true}
                  handleMenu={(data) => handleMenu(data)}
                  dataCy="supplier-po-list-table"
                  menu={(data) => (
                    <Popover id="popover-basic" data-cy="po-list-table-menu">
                      <Popover.Body>
                        <ul className="action-block-list">
                          {data && data.is_credit_invoice ? (
                            <>
                              {data && (
                                <li onClick={() => viewPO()} data-cy="view-po">View PO</li>
                              )}
                              <li onClick={() => viewInvoices()} data-cy="view-invoices">View Invoice</li>
                              {data && (
                                <li onClick={() => handleDownloadDialog(data.poId)} data-cy="download-po">Download PO</li>
                              )}
                              {writePermission && data.status === "Pending" && (
                                <li onClick={deleteDialogState} data-cy="delete-po">Delete</li>
                              )}
                            </>
                          ) : (
                            <>
                              {data && (
                                <li onClick={() => viewPO()} data-cy="view-po">View PO</li>
                              )}
                              {writePermission && data && data.status !== "Completed" && (
                                <li onClick={editPo} data-cy="edit-po">Edit PO</li>
                              )}
                              {data && (
                                <li onClick={() => handleDownloadDialog(data.poId)} data-cy="download-po">Download PO</li>
                              )}
                              {writePermission && data && data.materialstatus !== "Fully Received" && data.materialstatus !== "Over Received" && (
                                <li
                                  className={!(entitlements.receiveStock) && 'disabled'}
                                  onClick={() => (entitlements.receiveStock) && (() => props.history(`/${PROJECT_MANAGEMENT}/receive-stock/${data.projectId}/${data.vendorId}/${data.poId}`))()}
                                  data-cy="receive-stock"
                                >
                                  Receive Stock
                                </li>
                              )}
                              {writePermission && data && data.invoicestatus !== "Fully Invoiced" && (
                                <li onClick={() => handlePayInvoiceModal(true)} data-cy="receive-invoice">Receive Invoice</li>
                              )}
                              {writePermission && <li onClick={() => viewInvoices()} data-cy="view-invoices">View Invoices</li>}
                              {writePermission && data && data.status === "Pending" && (
                                <li onClick={deleteDialogState} data-cy="delete-po">Delete</li>
                              )}
                            </>
                          )}
                        </ul>
                      </Popover.Body>
                    </Popover>
                  )}
                  fileName='PO List'
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );

}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getPOList: bindActionCreators(getPOList, dispatch),
  getGlobalSettingTemplateTypes: bindActionCreators(getGlobalSettingTemplateTypes, dispatch),
  getProjectList: bindActionCreators(getProjectList, dispatch),
  deletePurchaseOrder: bindActionCreators(deletePurchaseOrder, dispatch),
  downloadProjectPO: bindActionCreators(downloadProjectPO, dispatch),
  warningSnackBar: bindActionCreators(warningSnackBar, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SuppliersPurchaseOrderList)
);
